/**
 *  Centralised collection of regular-expression patterns used
 *  across the application for client-side form validation.
 *
 *  • email        – Ensures a standard email format with a
 *                   mandatory dot-separated top-level domain.
 *  • phoneNumber  – Digits only, 7-20 characters (international
 *                   length range, no formatting symbols).
 *  • website      – Matches most HTTP/HTTPS URLs, with or without
 *                   "www", and allows optional port, path, query
 *                   parameters, and fragments.
 *  • postcode     – Generic 1-7 alphanumeric code (kept broad to
 *                   cover multiple country formats).
 *  • password     – Minimum 8 characters and at least one uppercase
 *                   letter, one lowercase letter, one digit, and one
 *                   special character for strong-password enforcement.
 *  • abn          – Australian Business Number: exactly 11 alpha-
 *                   numeric characters.
 *  • firstName    – Name validation: no special characters except spaces and hyphens
 *  • lastName     – Name validation: no special characters except spaces and hyphens
 *  • hourlyRate   – Positive decimal number validation
 *
 */
export const pattern = {
    email: "^([A-Za-z0-9._-])+@([A-Za-z0-9.-])+\.([A-Za-z]{2,})$",
    phoneNumber: "^[0-9]{7,20}$", // Allow empty string or valid phone number
    website: "^(https?:\\/\\/)?" + //Matches the optional protocol (http or https)
        "((www\\.[a-z\\d-]+(\\.[a-z\\d-]+)*\\.[a-z]{2,})" + //Matches URLs that start with "www." OR URLs that don't start with "www." (up to three dots)
        "|(?!www\\.)([a-z\\d-]+(\\.[a-z\\d-]+){0,2}\\.[a-z]{2,}))" +
        "\\/?$" + // Matches an optional trailing slash at the end of the domain part
        "(:\\d+)?" + //Matches the optional path
        "(\\/[-a-z\\d%_.~+]*)*" + //Matches the optional query parameters
        "(\\?[;&a-z\\d%_.~+=-]*)?" + //Matches the optional fragment (anchor)
        "(#[-a-z\\d_]*)?$",
    postcode: "^(?:[A-Za-z0-9]{1,7})?$",
    password: "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
    abn: "^[A-Za-z0-9]{11}$",
    firstName: /^(?!.*[`!@#$%^&*_=+?{}[]|:;"<>?]).*/,
    lastName: /^(?!.*[`!@#$%^&*_=+?{}[]|:;"<>?]).*/,
    hourlyRate: /^[0-9]+(\.[0-9]{1,2})?$/,
    specialChars: /[.*+?^${}()|[\]\\]/g
};